/* RESPONSIBLE TEAM: team-rd-services */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorScorecardRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.scorecard',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorScorecardRoute);
